'use strict';

import {openForethoughtAIChatbot} from "../../../../scripts/global/forethought-integration.util.js";

AppSideBarComponent.$inject = ['$q', '$scope', 'hUser', '$stateParams', 'brandServices', 'userPermissions', '$element', 'hTransitions', 'hmapService', '$timeout', '$state', 'appLayoutViewService', 'deviceChecker', 'useNavFactory', 'useWfmNavFactory', 'usePlatformNavFactory', 'localize'];

function AppSideBarComponent($q, $scope, hUser, $stateParams, brandServices, userPermissions, $element, hTransitions, hmapService, $timeout, $state, appLayoutViewService, deviceChecker, useNavFactory, useWfmNavFactory, usePlatformNavFactory, localize) {
    var self = this;

    const {wfmNav} = useWfmNavFactory($scope, isActiveLink, getBrandIds);

    self.navFactory = useNavFactory($scope);
    self.activeNavIndex = -1;
    let hoverOverSideNav;
    let hoverOverSideNavBody;
    const navDelayOpenTime = 250;
    const navDelayCloseTime = 500;

    const isTeamLiveAccessOnlyUser = (brandId) => {
        return new Promise((resolve, reject) => {
            userPermissions.getBrandPolicy(brandId)
                .then(policyParser => {
                    const hasAccessToSourceHire = policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE);
                    const hasAccessToTeam = policyParser.hasAccess(userPermissions.ACCESS_TYPES.TEAM);

                    resolve(hasAccessToTeam && !hasAccessToSourceHire);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    };

    function isActiveLink(stateName) {
        return $state.current.name?.startsWith(stateName);
    };

    function getBrandIds() {
        const brandIds = hUser.data.user.brands_list?.map((brand) => brand.id) || [];
        const groupId = hUser.getUserContext()['brand_id'];
        if (brandIds.length !== 1) {
            brandIds.push(groupId);
        }
        return brandIds;
    };

    self.toggleSideBar = function (source) {
        self.isSideBarExpanded = !self.isSideBarExpanded;
        self.enteredSideBarBody = false;
        appLayoutViewService.setToggleSource(source);
        appLayoutViewService.setSideBarState(self.isSideBarExpanded);

        if (source === appLayoutViewService.TOGGLE_SOURCE.HEADER && self.isSideBarExpanded) {
            self.navFactory.focusOnActiveItem();
        }

        if (
            source === appLayoutViewService.TOGGLE_SOURCE.SIDE_BAR ||
            (!self.isSideBarExpanded && source === appLayoutViewService.TOGGLE_SOURCE.HEADER)
        ) {
            HStorageManager.put({
                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                key: 'side_bar_state_{{id}}',
                value: self.isSideBarExpanded ? appLayoutViewService.SIDE_BAR_STATE.OPEN : appLayoutViewService.SIDE_BAR_STATE.CLOSED,
                variables: {
                    id: hUser.getUser().id
                }
            });
        }
        self.source = source;
        $scope.$evalAsync();
        hideInternalSideBarMenu();
        if (source === appLayoutViewService.TOGGLE_SOURCE.SIDE_BAR) {
            appLayoutViewService.triggerSideBarStateChange();
        }
    };

    self.isSideBarOpen = () => {
        return (self.isSideBarExpanded || self.enteredMainSideBar || self.enteredSideBarBody);
    };

    const updateLocationName = () => {
        BrandAPI.getBrandBasicInfo(hUser.getActiveBrandIdWithAccess())
            .then((brandBasicInfo) => {
                self.locationName = brandBasicInfo.name;
            })
            .catch((err) => {
                console.error(err);
            });
    };

    var hideInternalSideBarMenu = function () {
        $element.find('.expandable-item').removeClass('active-item');
    };

    self.onNavEnter = () => {
        hoverOverSideNav = true;
        $timeout(function () {
            if (hoverOverSideNav) {
                self.enteredMainSideBar = true;
            }
        }, navDelayOpenTime);
    };

    const resetSubNavs = () => {
        if (self.navFactory.state.activeNavs.length) {
            self.navFactory.state.activeNavs.length = 1;
        }
    };

    self.onNavLeave = () => {
        hoverOverSideNav = false;
        $timeout(function () {
            if (!hoverOverSideNav) {
                self.enteredMainSideBar = false;
                resetSubNavs();
                if (!self.isSideBarExpanded && self.navFactory.state.activeNavs[0]) {
                    self.navFactory.closeDropdowns(self.navFactory.state.activeNavs[0]);
                }
            }
        }, navDelayCloseTime);
    };

    self.onNavBodyEnter = (navIndex) => {
        hoverOverSideNavBody = true;
        self.activeNavIndex = navIndex;
        $timeout(function () {
            if (hoverOverSideNavBody) {
                self.enteredSideBarBody = true;
            }
        }, navDelayOpenTime);
    };

    self.onNavBodyLeave = (navIndex) => {
        hoverOverSideNavBody = false;
        if (self.activeNavIndex === navIndex) {
            self.activeNavIndex = -1;
        }
        $timeout(function () {
            if (!hoverOverSideNavBody) {
                self.enteredSideBarBody = false;
            }
        }, navDelayCloseTime);
    };

    const runSideBarListener = () => {

        $(document).on("click.app-side-bar", function (event) {
            if (
                $(event.target).parents('.app-side-bar-component').length === 0 &&
                self.isSideBarExpanded &&
                self.source === appLayoutViewService.TOGGLE_SOURCE.HEADER
            ) {
                self.toggleSideBar(appLayoutViewService.TOGGLE_SOURCE.USER_CLICK);
            }
        });

        hTransitions.onSuccess({}, function () {
            updateSideBarState();
        });
    };

    self.toggleSearchInput = (nav) => {
        nav.searchEnabled = !nav.searchEnabled;
    };

    var updateSideBarState = function () {
        var sideBarStateCache = HStorageManager.get({
            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
            key: 'side_bar_state_{{id}}',
            variables: {
                id: hUser.getUser().id
            }
        });

        if (sideBarStateCache) {
            appLayoutViewService.setSideBarState(sideBarStateCache === appLayoutViewService.SIDE_BAR_STATE.OPEN);
        }

        self.isSideBarExpanded = appLayoutViewService.isSideBarExpanded();

        if (
            (
                appLayoutViewService.checkIfHasNavBarMenu() ||
                self.source === appLayoutViewService.TOGGLE_SOURCE.HEADER
            ) &&
            self.isSideBarExpanded
        ) {
            self.toggleSideBar(appLayoutViewService.TOGGLE_SOURCE.USER_CLICK);
        }
    };

    self.onNavItemMouseEnter = (() => {
        let closeTimeout, openTimeout;

        return (activeNav, item) => {
            const navIndex = self.navFactory.state.activeNavs.indexOf(activeNav);

            if (navIndex === 0) {
                if (item.subNav?.length) {
                    clearTimeout(closeTimeout);
                    clearTimeout(openTimeout);
                    closeTimeout = undefined;
                    openTimeout = setTimeout(() => {
                        if (navIndex === self.activeNavIndex) {
                            self.navFactory.openSubNav(item.subNav, self.navFactory.state.activeNavs.indexOf(activeNav) + 1);
                            $scope.$digest();
                        }
                    }, self.navFactory.state.activeNavs.length > 1? 150: 0);
                } else {
                    closeTimeout ??= setTimeout(() => {
                        if (navIndex === self.activeNavIndex) {
                            resetSubNavs();
                            $scope.$digest();
                        }

                        closeTimeout = undefined;
                    }, 300);
                }
            }
        };
    })();

    self.goToMainMenu = (subNav) => {
        self.navFactory.closeSubNav(subNav);
    };

    self.onNavItemMouseLeave = _.debounce((activeNav, item) => {
        if (
            !self.enteredSideBarBody &&
            self.navFactory.state.activeNavs.indexOf(activeNav) === 0
        ) {
            self.navFactory.closeSubNav(item.subNav);
        }
    }, 300);

    self.onNavItemClick = (event, activeNav, item) => {
        item.onClick?.(event);
        if (
            item.subNav?.length &&
            self.navFactory.state.activeNavs.indexOf(activeNav) > 0
        ) {
            self.navFactory.openSubNav(item.subNav, self.navFactory.state.activeNavs.indexOf(activeNav) + 1);
        }
    };

    self.$onInit = function () {
        self.userInfo = {};
        self.userInfo.id = hUser.data.user.id;
        self.isHMAPUser = hUser.isHMAPUser();

        Promise.all([
            brandServices.check(brandServices.SERVICES.ONBOARDING_JOURNEY, hUser.getEntryMode().brand_id, true),
            PerformanceAggregatorAPI.getTipsDistributionSettings(hUser.getEntryMode().brand_id)
        ])
            .then(([isOnboardingJourneyEnabled, tipsDistributionSettings]) => {
                self.isOnboardingJourneyEnabled = isOnboardingJourneyEnabled;
                self.canViewTipsDistribution = tipsDistributionSettings?.bulk_tips_distribution_enabled;
            })
            .finally(() => {
                $scope.$digest();
            });

        updateSideBarState();
        initNav();
        updateLocationName();
    };


    const initNav = () => {
        self.loadingSideBarItems = true;
        self.enteredMainSideBar = false;
        self.enteredSideBarBody = false;
        resetSubNavs();
        const {platformNav} = usePlatformNavFactory($scope, $stateParams['hmapPath'], isActiveLink, getBrandIds);

        isTeamLiveAccessOnlyUser(hUser.getUserContext().brand_id)
            .then(isTeamLiveAccessOnly => {
                self.navFactory.init(isTeamLiveAccessOnly && !hUser.isHMAPUser() ? wfmNav : platformNav)
                    .finally(() => {
                        self.loadingSideBarItems = false;
                        $scope.$digest();
                    });
            });
    }

    hmapService.onActiveBrandChanged(() => {
        initNav()
    });

    const brandsListUpdatedEvent = hUser.onBrandsListUpdated(() => {
        initNav();
        updateLocationName();
    });

    self.redirectToSupport = () => {
        brandServices.check(brandServices.SERVICES.ONBOARDING_JOURNEY, hUser.getEntryMode().brand_id, true)
            .then((isOnboardingJourneyEnabled) => {
                if (isOnboardingJourneyEnabled) {
                    window.open('https://live.hornbill.com/mcdonaldspshd', "_blank ");
                } else {
                    Utils.redirectToCommunitySupport(true);
                }
            })
            .catch(console.error);
    };

    self.$onDestroy = function () {
        $(document).off("click.app-side-bar");
        hUser.off(brandsListUpdatedEvent);
    };

    self.$onChanges = function (changesObj) {

    };

    self.getHmapPath = function () {
        return $stateParams.hmapPath;
    };

    self.getActiveBrandId = function () {
        return hUser.getActiveBrandId();
    };

    self.isTopLevelContext = function () {
        return hUser.isTopLevelContext();
    };

    self.isHMAPUser = function () {
        return hUser.isHMAPUser();
    };

    self.$postLink = function () {
        runSideBarListener();
    };

    self.isActiveLink = (stateName) => {
        return $state.current.name?.startsWith(stateName);
    };

    self.toggleDropdown = function (togglingVariable) {
        self[togglingVariable] = !self[togglingVariable];
    };

    self.hasActiveRoute = function (route) {
        return $state.current.name.startsWith(route);
    };

    self.toggleSubSideMenu = function (event) {
        if (!deviceChecker.isMobile()) {
            return;
        }

        event && event.stopPropagation();
        $(event.target).parents('li').toggleClass('active-item');
    };

    appLayoutViewService.on(appLayoutViewService.EVENTS.TOGGLE_SIDE_BAR, function (source) {
        self.toggleSideBar(source);
    });

    self.openForethoughtChatBot = () => {
        openForethoughtAIChatbot(localize.getLang());
    }

}

angular
    .module("harriApp")
    .component("appSideBar", {
        controller: AppSideBarComponent,
        bindings: {},
        controllerAs: '$ctrl',
        templateUrl: '../hmodules/harri-main/components/app-side-bar/app-side-bar.component.html'
    });
